// Styles
import styles from './SectionTitle.module.css';

export const SectionTitle = ({ title }) => {
  return <h4 className={styles.sectionTitle}>{title}</h4>
};
